import { render } from "./vue-number-input.vue?vue&type=template&id=7adec91a&scoped=true"
import script from "./vue-number-input.vue?vue&type=script&lang=js"
export * from "./vue-number-input.vue?vue&type=script&lang=js"

import "./vue-number-input.vue?vue&type=style&index=0&id=7adec91a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7adec91a"]])

export default __exports__